import { setLocale } from 'yup';
import { i18n } from 'i18n';

// Default messages for schema rules declared without an explicit message (e.g. a bare `.required()`),
// which otherwise surface yup's English "<key> is a required field". Function form so the active
// language is read when validation runs, not when the schema module is first imported. This module
// must be imported before any schema is built — it is the first import in index.tsx.
setLocale({
  mixed: {
    required: () => i18n._('This field is required'),
    notType: () => i18n._('Invalid value'),
  },
  string: {
    email: () => i18n._('Must be a valid email address'),
  },
  number: {
    min: ({ min }) => `${i18n._('Must be at least')} ${min}`,
    max: ({ max }) => `${i18n._('Must be at most')} ${max}`,
  },
});
